import {sendEvent} from './helpers/EventUtils';
import {exposeForCypress} from './tests/utils';

declare global {
    interface Window {
        postEventToParentWindow?: (payload: any) => void;
        exposeForCypress?: (iframeWindow: Window) => void;
    }
}

// Poskytuje globální funkci, kterou volají FTL šablony: postEventToParentWindow({...})
// Normalizuje payloady a buď předá hotový EVENT payload rodičovskému oknu,
// nebo převede jednoduchý objekt události na tvar {type:'EVENT', sender:'mapio', instanceId, event}
globalThis.postEventToParentWindow = (payload: any) => {
    try {
        if (!payload) return;

        // Pokud volající již poskytl kompletní obálku, předej ji rodičovskému oknu
        if (payload.type === 'EVENT' && payload.sender) {
            if (globalThis.self !== globalThis.top) {
                globalThis.parent.postMessage(payload, '*'); // NOSONAR
            }
            return;
        }
        // Předej do funkce sendEvent aplikace, která provede postMessage rodičovskému oknu při běhu v iframe
        sendEvent(payload);
    } catch (e) {
        // Ignoruj chyby - šablony volají tuto funkci přímo a nechceme, aby se kvůli tomu rozbily
        // console.error('postEventToParentWindow error', e);
    }
};

// Nastav exposeForCypress pro Cypress testy
globalThis.exposeForCypress = exposeForCypress;
